"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = NotFound;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require("react-helmet");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function NotFound() {
  return _react2.default.createElement(
    "div",
    null,
    _react2.default.createElement(_reactHelmet2.default, { title: "Sivua ei l\xF6ytynyt" }),
    _react2.default.createElement(
      "h1",
      null,
      "Doh! 404!"
    ),
    _react2.default.createElement(
      "p",
      null,
      "Etsim\xE4\xE4si sivua ei l\xF6ytynyt."
    )
  );
}
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/NotFound/NotFound.js
 ** module id = 1223
 ** module chunks = 0
 **/